(function () {
  'use strict';

  const root = document.documentElement;
  let stickyObserver;
  let observedSticky;

  function updateStickyClearance() {
    const sticky = document.querySelector('[data-pa-sticky]');

    if (!sticky) {
      root.style.removeProperty('--pa-sticky-clearance');
      stickyObserver?.disconnect();
      stickyObserver = undefined;
      observedSticky = undefined;
      return;
    }

    const bottom = Number.parseFloat(window.getComputedStyle(sticky).bottom) || 0;
    const clearance = Math.ceil(sticky.getBoundingClientRect().height + bottom + 22);
    root.style.setProperty('--pa-sticky-clearance', `${Math.max(clearance, 104)}px`);

    if (window.ResizeObserver && sticky !== observedSticky) {
      stickyObserver?.disconnect();
      stickyObserver = new ResizeObserver(updateStickyClearance);
      stickyObserver.observe(sticky);
      observedSticky = sticky;
    }
  }

  function scheduleUpdate() {
    window.requestAnimationFrame(updateStickyClearance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
  } else {
    scheduleUpdate();
  }

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('shopify:section:unload', scheduleUpdate);
})();
